/**
 * Formats a price in cents to a display string.
 * - 0 → "Free"
 * - Whole dollar amounts → "$85", "$1,200"
 * - Amounts with cents → "$85.50", "$12.99"
 */
export function formatPrice(cents: number): string {
  if (!cents || cents === 0) return 'Free';

  const dollars = cents / 100;

  if (cents % 100 === 0) {
    return `$${dollars.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
  }

  return `$${dollars.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

/**
 * Formats a dollar amount (not cents) for display.
 * Use this when the input is already in dollars (e.g., from a text input).
 * - 0 → "Free"
 * - Whole dollars → "$85"
 * - With decimals → "$85.50"
 */
/**
 * Formats a price in cents, always showing 2 decimal places.
 * Use on financial/accounting screens (e.g., Earnings).
 * - 0 → "$0.00"
 * - 8500 → "$85.00"
 * - 8550 → "$85.50"
 */
export function formatPriceExact(cents: number): string {
  const dollars = cents / 100;
  return `$${dollars.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export function formatDollars(dollars: number): string {
  if (!dollars || dollars === 0) return 'Free';

  if (Number.isInteger(dollars)) {
    return `$${dollars.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
  }

  return `$${dollars.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}
